export default {
  MBFIA00001: 'Internal server error.',
  MBFIA00002: 'Forbidden.',
  MBFIA00003: 'Bad request.',
  MBFIA00004: 'Admin modification not allowed.',
};
